/**
 * Import libraries and ts-files.
 */
import Alpine from 'alpinejs'
import { initGSAP } from "./gsap";
import { initHeader } from './header';
import { initAccessibility } from './accessibility';
import { initCarousel } from './carousel';
import { initSwiper } from './swiper';
import { initGlobal } from './global';

/**
 * Initialize code.
 */
Alpine.start();
initAccessibility();
initHeader();
initGSAP();
initCarousel();
initSwiper();
initGlobal();